import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f786936"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid-slider": "",
  class: "slider is-flex"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-left" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ml-2 is-hidden-desktop" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 is-hidden-desktop" }, null, -1))
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-long-arrow-alt-right" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "slider-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwipeArrows = _resolveComponent("SwipeArrows")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.entities.length > 4)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            "data-testid-button-prev": "",
            class: "circle is-hidden-touch",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prev())),
            "aria-label": _ctx.$t('general.previous')
          }, _hoisted_4, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "slider-container",
        ref: "container",
        onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
      }, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entities, (entity) => {
          return (_openBlock(), _createElementBlock("div", {
            "data-testid-container": "",
            class: "slider-container-slot",
            key: entity['@id']
          }, [
            _renderSlot(_ctx.$slots, "default", { entity: entity }, undefined, true)
          ]))
        }), 128)),
        _hoisted_6
      ], 544),
      (_ctx.entities.length > 4)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            "data-testid-button-next": "",
            class: "circle is-hidden-touch",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.next())),
            "aria-label": _ctx.$t('general.next')
          }, _hoisted_9, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_SwipeArrows, {
        onPrev: _ctx.prev,
        onNext: _ctx.next
      }, null, 8, ["onPrev", "onNext"])
    ])
  ], 64))
}